import Vue                from 'vue'
import Help               from './components/misc/Help.vue'
import Contact            from './components/misc/Contact.vue'
import CarForSaleAllView  from './components/CarForSaleAllView.vue'
import CarForSaleView     from './components/CarForSaleView.vue'
import CarForSaleAdd      from './components/CarForSaleAdd.vue'
import CarForSaleAddPre   from './components/CarForSaleAddPre.vue'

import AdminMain          from './components/admin/AdminMain.vue'
import BankAdmin          from './components/admin/BankAdmin.vue'
import CarBrandAdmin      from './components/admin/CarBrandAdmin.vue'
import CarForSaleAdmin    from './components/admin/CarForSaleAdmin.vue'
import CarModelAdmin      from './components/admin/CarModelAdmin.vue'
import InquiryAdmin       from './components/admin/InquiryAdmin.vue'

import Main               from './components/Main.vue'
import Generic            from './components/misc/Generic.vue'
import Home               from './components/misc/Home.vue'
import Gallery            from './components/misc/Gallery.vue'

import Login              from './components/membership/Login.vue'
import Register           from './components/membership/Register.vue'

export const routes = [
    { path:'',                              component: Home },
    { path:'/view',                         component: Main, children: [
        { path:'',                          component: CarForSaleAllView },
        { path:':offset',                   component: CarForSaleAllView, name:'view' },
        { path:':offset/brand/:brand',      component: CarForSaleAllView },
        { path:':offset/model/:model',      component: CarForSaleAllView },    
        { path:':offset/year/:year',        component: CarForSaleAllView },    
        { path:'carforsaleview/:id',        component: CarForSaleView },
        { path:'gallery/:id/:imageIndex',   component: Gallery },
    ]},
    { path:'/admin',                        component: AdminMain, beforeEnter: (to, from, next) => {            
        Vue.http.get('api/login').then(response => {                                                                                      
            if(response.body.isAdmin == 1){
                next();
            }
            else {
                next('/membership/login');
            }
        }, response => {                  
            next('/membership/login');
        });
        
    }, children: [        
        { path:'carforsaleaddpre',          component: CarForSaleAddPre },
        { path:'inquiryadmin',              component: InquiryAdmin },
        { path:'inquiryadmin/:offset',      component: InquiryAdmin},
        { path:'carforsaleadmin',           component: CarForSaleAdmin },
        { path:'carforsaleadmin/:offset',   component: CarForSaleAdmin },
        { path:'bankadmin',                 component: BankAdmin },
        { path:'bankadmin/:offset',         component: BankAdmin },
        { path:'carbrandadmin',             component: CarBrandAdmin },
        { path:'carmodeladmin',             component: CarModelAdmin },                    
    ]},            
    { path:'/membership',                   component: Generic, children: [        
        { path:'login',                     component: Login },
        { path:'register',                  component: Register },        
    ]},                
    { path:'/ayuda',                        component: Help },    
    { path:'/contacto',                     component: Contact },        
    { path:'/view/carforsaleview/:id',      component: CarForSaleView },    
];


// WEBPACK FOOTER //
// ./src/routes.js